__webpack_require__.p = "https://bundle.stayforlong.com/20260126.1/_next/";